import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';
import styles from './index.module.scss';
import { ShareDataUnityPowerMapContext, IndexTimeActive } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import {
  apiV2ElectricMapDataElectricityOverviewPost,
  V2ElectricMapDataElectricityOverviewPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';
import { getLineChartOption } from '../chart';
import titleIcon from '@/assets/images/title_icon.png';

const ElectricityCostLeft = () => {
  const theme = useTheme();
  const { timeResolution: activeKey, dateValue: value, rightExpanded } = useContext(ShareDataUnityPowerMapContext);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [originData, setOriginData] = React.useState<V2ElectricMapDataElectricityOverviewPostResponse>();

  const lineChartRef = useRef<EchartsWithThemeRef>(null);
  const containerRefLine = useRef(null);

  useEffect(() => {
    if (!value || !activeKey) return;
    setLoading(true);
    apiV2ElectricMapDataElectricityOverviewPost({
      timeResolution: activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y',
      start: getDefaultTime(activeKey, value).startTime,
      end: getDefaultTime(activeKey, value).endTime,
    })
      .then(res => {
        setOriginData(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activeKey, value]);

  const chartLineOption = useMemo(
    () => getLineChartOption(originData?.data, activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y'),
    [originData?.data, activeKey]
  );

  // ResizeObserver 监听容器大小变化
  useEffect(() => {
    const resizeObserverLine = new ResizeObserver(() => {
      const echartsInstanceLine = lineChartRef.current?.getInstance();
      if (echartsInstanceLine) {
        echartsInstanceLine.resize();
      }
    });

    if (containerRefLine.current) {
      resizeObserverLine.observe(containerRefLine.current);
    }

    return () => {
      resizeObserverLine.disconnect();
    };
  }, []);

  // 监听展开状态变化，延迟触发 resize
  useEffect(() => {
    if (rightExpanded) {
      setTimeout(() => {
        const echartsInstanceLine = lineChartRef.current?.getInstance();
        if (echartsInstanceLine) {
          echartsInstanceLine.resize();
        }
      }, 100);
    }
  }, [rightExpanded]);

  return (
    <Spin spinning={loading}>
      <div className={styles.container} ref={containerRefLine}>
        <div className={styles.titleRow}>
          <img src={titleIcon} alt="" />
          <div>用电成本</div>
        </div>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !originData?.data || originData?.data.length === 0,
            emptyNode: <Empty style={{ marginTop: 20 }} />,
          }}
          ref={lineChartRef}
          option={chartLineOption}
          style={{ height: 256, width: '100%' }}
          theme={theme}
        />
      </div>
    </Spin>
  );
};

export default ElectricityCostLeft;
